'use client';

import { c as _c } from "react/compiler-runtime";
import { RadioCardGroup } from '@/shared/components/ui';
import type { FormatoDownload } from '../../types/baixarProcesso.types';
import { FORMATOS_DOWNLOAD, ICONE_POR_FORMATO } from '../../utils/formatosDownload';
interface EtapaEscolhaFormatoProps {
  formatoEmEscolha: FormatoDownload | null;
  onMarcar: (formato: FormatoDownload) => void;
}
function ehFormato(valor: string): valor is FormatoDownload {
  return FORMATOS_DOWNLOAD.some(opcao => opcao.chave === valor);
}

/**
 * A escolha de formato dentro do painel, para quem não tem o menu do cabeçalho (a Secretaria).
 * Não há mock desta etapa: os cartões reaproveitam o `RadioCardGroup` e os textos do menu do
 * escritório — gancho para a designer aprovar ou trocar.
 */
export function EtapaEscolhaFormato(t0) {
  const $ = _c(7);
  const {
    formatoEmEscolha,
    onMarcar
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-[12px] font-medium text-neutral-600" id="formato-do-download">Formato do download</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onMarcar) {
    t2 = valor => {
      if (ehFormato(valor)) {
        onMarcar(valor);
      }
    };
    $[1] = onMarcar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = formatoEmEscolha ?? "";
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = FORMATOS_DOWNLOAD.map(_temp);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t3) {
    t5 = <div className="flex min-h-0 w-full flex-1 flex-col gap-2 overflow-y-auto px-6 pt-[18px] pb-6">{t1}<RadioCardGroup aria-labelledby="formato-do-download" className="flex-col flex-nowrap" onValueChange={t2} value={t3}>{t4}</RadioCardGroup></div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp(opcao) {
  return <RadioCardGroup.RadioCard className="gap-3" key={opcao.chave} value={opcao.chave}><span className="flex items-center gap-2"><span className="text-brand-600 flex-none">{ICONE_POR_FORMATO[opcao.chave]}</span><span className="text-default-font text-[13.5px] font-medium">{opcao.titulo}</span></span><span className="text-[12px] leading-[1.5] text-neutral-500">{opcao.descricao}</span></RadioCardGroup.RadioCard>;
}